import React from "react";

const PeopleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <g clipPath="url(#clip0_1769_7272)">
        <path
          d="M12.75 24.5C12.75 24.5 11 24.5 11 22.75C11 21 12.75 15.75 19.75 15.75C26.75 15.75 28.5 21 28.5 22.75C28.5 24.5 26.75 24.5 26.75 24.5H12.75ZM19.75 14C21.1424 14 22.4777 13.4469 23.4623 12.4623C24.4469 11.4777 25 10.1424 25 8.75C25 7.35761 24.4469 6.02226 23.4623 5.03769C22.4777 4.05312 21.1424 3.5 19.75 3.5C18.3576 3.5 17.0223 4.05312 16.0377 5.03769C15.0531 6.02226 14.5 7.35761 14.5 8.75C14.5 10.1424 15.0531 11.4777 16.0377 12.4623C17.0223 13.4469 18.3576 14 19.75 14ZM9.628 24.5C9.36869 23.9536 9.23932 23.3547 9.25 22.75C9.25 20.3787 10.44 17.9375 12.638 16.24C11.5411 15.9013 10.398 15.7359 9.25 15.75C2.25 15.75 0.5 21 0.5 22.75C0.5 24.5 2.25 24.5 2.25 24.5H9.628ZM8.375 14C9.53532 14 10.6481 13.5391 11.4686 12.7186C12.2891 11.8981 12.75 10.7853 12.75 9.625C12.75 8.46468 12.2891 7.35188 11.4686 6.53141C10.6481 5.71094 9.53532 5.25 8.375 5.25C7.21468 5.25 6.10188 5.71094 5.28141 6.53141C4.46094 7.35188 4 8.46468 4 9.625C4 10.7853 4.46094 11.8981 5.28141 12.7186C6.10188 13.5391 7.21468 14 8.375 14Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1769_7272">
          <rect
            width="28"
            height="28"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PeopleIcon;
